<template>

</template>
<script>
import axios from '@/axios';
import Vue from 'vue'
import rutasjson from "@/assets/utils/rutas.json"


const asyncLocalStorage = {
    setItem: function (key, value) {
        return Promise.resolve().then(function () {
            //localStorage.setItem(key, value);
            Vue.cookie.set(key, value, {domain: rutasjson.domain});
        });
    },
};

export default {
    mounted(){
        // console.log(this.$route.query, this.$route.params)
        axios.post('api/empresa/login_con_activacion_empresa/',
            {
                token_empresa: this.$route.params.token_empresa,
                token_usuario: this.$route.params.token_usuario,
            }
        ).then(response => {
            if(response.data.token !== undefined) {
              asyncLocalStorage.setItem('usuario', JSON.stringify(response.data)).then(() => {
                let usuario_saved = this.$cookie.get('usuario')
                this.$store.commit('custom/set_user', usuario_saved)
                let userJson = JSON.parse(usuario_saved)
                this.username = userJson.username
                axios.defaults.headers.common['Authorization'] = 'Token ' + userJson.token
                //redireccionar a home con subdominio de empresa
                // console.log("redirecciona a urlhomeEmpresa")
                window.location.href = userJson.url_home_empresa
                // if(this.$route.query.plan != undefined){
                //     this.$router.push("/plan/checkout/"+this.$route.query.plan)
                // }else{
                //     this.$router.push({name: 'page-home-token', params: {token_activate: this.$route.params.token}})
                // }
              });
            }
            else{
              window.location.href = rutasjson.rutaCompleta
            }
        })
    }
}
</script>
